import { render, staticRenderFns } from "./CustomerPopover.vue?vue&type=template&id=88ee5d7c&"
import script from "./CustomerPopover.vue?vue&type=script&lang=js&"
export * from "./CustomerPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerPopover.vue"
export default component.exports